import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/700.css';
import '@amzn/awsui-global-styles/polaris.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { applyTheme } from '@amzn/awsui-components-core/theming';
import App from './components/App';
import { isFeatureEnabled } from './common/EnvironmentConfig';
import './resources/styles/scss/app.scss';
import '@amzn/awscat-editor/dist/awscat-editor.css';
import './index.scss';

if (isFeatureEnabled('UxRedesign')) {
  const fontFamilyStack = '"Open Sans", "Helvetica Neue", Roboto, Arial, sans-serif';

  applyTheme({
    theme: {
      tokens: {
        colorBackgroundLayoutMain: { light: '#fcfcfd' },
        colorTextBodyDefault: { light: '#0f141a' },

        fontFamilyBase: fontFamilyStack,
        fontFamilyDisplay: fontFamilyStack,
        fontFamilyHeading: fontFamilyStack,

        fontWeightNormal: '400',
        fontWeightBold: '700',
        fontWeightHeavy: '700',
        fontWeightLighter: '300',

        // Body
        fontSizeBodyS: '12px',
        lineHeightBodyS: '16px',
        fontSizeBodyM: '14px',
        lineHeightBodyM: '20px',

        // Heading XS (extrapolated ~H5)
        fontSizeHeadingXs: '12px',
        lineHeightHeadingXs: '16px',
        fontWeightHeadingXs: '700',
        letterSpacingHeadingXs: '0',

        // Heading S (extrapolated ~H4)
        fontSizeHeadingS: '14px',
        lineHeightHeadingS: '18px',
        fontWeightHeadingS: '700',
        letterSpacingHeadingS: '0',

        // Heading M (extrapolated ~H3)
        fontSizeHeadingM: '16px',
        lineHeightHeadingM: '20px',
        fontWeightHeadingM: '700',
        letterSpacingHeadingM: '-0.005em',

        // Heading L (~H2 / panel header, from sample)
        fontSizeHeadingL: '18px',
        lineHeightHeadingL: '22px',
        fontWeightHeadingL: '700',
        letterSpacingHeadingL: '-0.01em',

        // Heading XL (~H1, from sample)
        fontSizeHeadingXl: '24px',
        lineHeightHeadingXl: '30px',
        fontWeightHeadingXl: '700',
        letterSpacingHeadingXl: '-0.02em',

        // Display (extrapolated)
        fontSizeDisplayL: '32px',
        lineHeightDisplayL: '40px',
        fontWeightDisplayL: '700',
        letterSpacingDisplayL: '-0.025em',
        fontSizeDisplayXl: '44px',
        lineHeightDisplayXl: '54px',
        fontWeightDisplayXl: '700',
        letterSpacingDisplayXl: '-0.03em',

        // Tabs
        fontSizeTabs: '16px',
        lineHeightTabs: '20px',
        fontWeightTabs: '700',

        // Form label
        fontSizeFormLabel: '14px',
        lineHeightFormLabel: '20px',
        fontWeightFormLabel: '700',

        // Buttons / alerts / flashbar
        fontWeightButton: '700',
        fontWeightAlertHeader: '700',
        fontWeightFlashbarHeader: '700',
        fontWeightBreadcrumbCurrent: '400',

        // Key-value pairs
        fontSizeKeyValuePairsLabel: '14px',
        lineHeightKeyValuePairsLabel: '20px',
        fontWeightKeyValuePairsLabel: '700',
      },
    },
  });
}

const rootElement = document.getElementById('mpc-app-root');
if (!rootElement) {
  throw new Error('Missing #mpc-app-root element');
}
createRoot(rootElement).render(<App className="awsui" />);
